export default __webpack_public_path__ + "7c4f779f831ed5b4a98014bc2da2849c.woff";